// extracted by mini-css-extract-plugin
export var label = "_dm-1";
export var reminder = "_dm-0";